import { Location } from "../../../Models/Location";

/**
 * Builds a human-readable label for a Location.
 *
 * Ensures correct spacing and punctuation even when
 * some fields are missing. Produces a clean, localized
 * postal-style address:
 *
 *   "Via Roma 10, 10121 Torino TO, ITA"
 *
 * @param location - The Location entity containing address fields.
 * @returns A formatted address string.
 */
export const buildLocationLabel = (location: Location): string => {
  if (!location) return "";

  const streetPart = [location.street, location.houseNumber]
    .filter(Boolean)
    .join(" ");

  const cityPart = [location.postalCode, location.municipality]
    .filter(Boolean)
    .join(" ");

  const regionPart = [location.subRegionName].filter(Boolean).join(" ");

  const country = location.countryIsoCode3 || "";

  // Assemble and remove empty segments
  return [streetPart, cityPart, regionPart, country]
    .filter((s) => s && s.trim().length > 0)
    .join(", ");
};
